import React, { Component } from "react";
import {Grid, Modal, TextField} from "@material-ui/core";
import { primaryColor, webFont } from "../../config/theme";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar/Avatar";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import { HourglassEmptyOutlined } from "@material-ui/icons";
import Header from "../../components/Header";
import Footer from "../../components/Footer/FooterLoggedIn";
import Button from "@material-ui/core/Button/Button";
import { connect } from "react-redux";
import moment from "moment";
import { GET_CHEF_DETAILS } from "../../graphql/queries/chef";
import { getCurrentBooking } from "../../redux/chefs";
import { client } from "../../config/apollo";
import {
  CANCEL_BOOKING,
  UPDATE_BOOKING
} from "../../graphql/mutations/booking";
import { USER_PROFILE } from "../../graphql/queries/user";
import LinearProgress from "@material-ui/core/LinearProgress";
import { BOOKING_STATUS } from "../../config/constants";
import { NotificationManager } from "react-notifications";
import { parseAmountDecimal } from "../../utils/common-methods";
import Fab from "@material-ui/core/Fab/Fab";
import Breadcrumbs from "../../components/Breadcrumbs";

class DinerBookingStatus extends Component {
  constructor(props) {
    super(props);
    const { isChef } = props;

    const declinedName = isChef ? "you" : props.booking.chefName;

    this.state = {
      currentStatus: 0,
      statusList: [
        {
          status: 0,
          message: "We're waiting for the chef to review the engagement.",
          name: "Pending"
        },
        {
          status: 1,
          message: `This booking has been declined by ${declinedName}.`,
          name: "Declined"
        },
        {
          status: 1,
          message: isChef ? `${props.booking.userName} has canceled the booking.` : "You have canceled the booking.",
          name: "Canceled",
        },
        {
          status: 1,
          message: isChef ? `${props.booking.userName} has canceled the booking.` : "You have canceled the booking.",
          name: "CANCELED_APPROVED_BY_DINER",
        },
        {
          status: 1,
          message: isChef ? "You have canceled the booking." : `${props.booking.chefName} has canceled the booking.`,
          name: "CANCELED_APPROVED_BY_CHEF",
        },
        {
          status: 1,
          message: "Your booking has expired due to lapse of time.",
          name: "EXPIRED",
        },
        {
          status: 1,
          message: "Your booking has been declined by the chef.",
          name: "Rejected",
        },
        {
          status: 2,
          message: "",// "Yay! Your booking has been confirmed by the chef.",
          name: "Accepted"
        },
        {
          status: 3,
          message: "", //"Yay! Your booking has been completed.",
          name: "Completed"
        },
        {
          status: 3,
          message:"", // "Yay! Your booking has been completed.",
          name: "COMPLETED_BY_USER"
        },
        {
          status: 3,
          message: "", // "Yay! Your booking has been completed.",
          name: "COMPLETED_BY_CHEF"
        }
      ],
      chefDetails: {},
      userDetails: {},
      loading: false,
      showCancelModal: false,
      cancelReason: '',
      cancelBooking: false,
      askCancelBooking: false,
      isScheduleScreen: false
    };
  }

  componentWillMount() {
    this.props.dispatch(getCurrentBooking());
  }

  closeCancelModal = () => {
    this.setState({ showCancelModal: false })
  }

  cancelBooking = () => {
    const { booking } = this.props;
    if (booking.status === BOOKING_STATUS.ACCEPTED || booking.status === BOOKING_STATUS.PENDING) {
      this.setState({ askCancelBooking: true });
    } else {
      this.handleCancelBooking();
    }
  };

  handleCancelBooking = () => {
    this.closeCancelModal();
    this.setState({ showCancelModal: false, askCancelBooking: false })
    const { booking, isChef } = this.props;
    this.setState({ loading: true });
    const cancelPayload = {
      bookingId: booking.id,
      status: isChef ?
        booking.status === BOOKING_STATUS.ACCEPTED ?
          BOOKING_STATUS.CANCELED_APPROVED_BY_CHEF :
          BOOKING_STATUS.CANCELED_BY_CHEF :
        booking.status === BOOKING_STATUS.ACCEPTED ?
          BOOKING_STATUS.CANCELED_APPROVED_BY_DINER :
          BOOKING_STATUS.CANCELED_BY_DINER
    };

    if (this.state.cancelReason) {
      cancelPayload.rejectReason = this.state.cancelReason;
    }

    client
      .mutate({
        mutation: UPDATE_BOOKING,
        variables: cancelPayload
      })
      .then(res => {
        this.setState({ loading: false });

        if (this.props.isChef) {
          this.props.history.push("/home/chef-bookings?step=1");
        }
        else {
          this.props.history.push("/home/diner-bookings?step=1");
        }
      })
      .catch(err => {
        let errorObj = JSON.parse(JSON.stringify(err));
        if (errorObj.graphQLErrors) {
          errorObj.graphQLErrors.map(error => {
            NotificationManager.error(error.message, "Booking");
          });
        }
        this.setState({ loading: false });
      });
  }

  componentDidMount() {
    const { booking } = this.props;
    const { search } = this.props.location;
    if (search === '?ps=schedule') {
      this.setState({ isScheduleScreen: true });
    }
    if (booking) {
      client
        .query({
          query: GET_CHEF_DETAILS,
          variables: {
            id: booking.chefId
          },
          fetchPolicy: "network-only"
        })
        .then(res => {
          this.setState({ chefDetails: res.data });
        })
        .catch(err => {
          console.log(err);
        });

      client
        .query({
          query: USER_PROFILE,
          variables: {
            userId: booking.userId
          }
        })
        .then(resp => {
          this.setState({ userDetails: resp.data });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  getStatusInfo = Status => {
    return this.state.statusList.find(status => {
      return status.name.toLowerCase() === Status.toLowerCase();
    });
  };

  addReview = (booking) => {
    this.props.history.push("/home/review",{booking});
  };

  addDispute = (booking) =>{
    this.props.history.push("/home/raise-dispute",{booking});
  };

  render() {
    const { chefDetails, userDetails } = this.state;
    const { booking, isChef } = this.props;

    if (!booking) {
      if (isChef) {
        this.props.history.push("/home/chef-bookings?step=1");
      }
      else {
        this.props.history.push("/home/diner-bookings?step=1");
      }
      return <p>Bookings not found</p>;
    }

    let bookingBackStep = 1;
    if (isChef) {
      if (booking.status === BOOKING_STATUS.ACCEPTED) {
        bookingBackStep = 2;
      }

      if (booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_DINER || booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_CHEF || booking.status === BOOKING_STATUS.CANCELED_BY_DINER ||
          booking.status === BOOKING_STATUS.CANCELED || booking.status === BOOKING_STATUS.CANCELED_BY_CHEF || booking.status === BOOKING_STATUS.COMPLETED ||
          booking.status === BOOKING_STATUS.COMPLETED_BY_USER || booking.status === BOOKING_STATUS.COMPLETED_BY_CHEF || booking.status === BOOKING_STATUS.REJECTED) {
        bookingBackStep = 3;
      }
    } else {
      if (booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_DINER || booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_CHEF ||
          booking.status === BOOKING_STATUS.CANCELED || booking.status === BOOKING_STATUS.CANCELED_BY_CHEF || booking.status === BOOKING_STATUS.COMPLETED ||
          booking.status === BOOKING_STATUS.COMPLETED_BY_USER || booking.status === BOOKING_STATUS.COMPLETED_BY_CHEF || booking.status === BOOKING_STATUS.CANCELED_BY_DINER ||
          booking.status === BOOKING_STATUS.EXPIRED || booking.status === BOOKING_STATUS.REJECTED) {
        bookingBackStep = 2;
      }

      if (booking.status === BOOKING_STATUS.INCOMPLETE) {
        bookingBackStep = 3;
      }
    }

    let total = booking.isCustom ? booking.amount : 0; let showDispute = false;
    let status = this.getStatusInfo(booking.status);

    if (booking.dishes) {
      booking.dishes.forEach(dish => {
        total += dish.price;
      });
    }
    let serviceCharges = 0;

    if (!isChef) {
      serviceCharges = (booking.serviceCharges ? booking.serviceCharges : parseFloat((total * 0.05).toFixed(2)));
      total = total + serviceCharges;
    } /* else {
      total = total - (booking.transactionFee || 0);
    } */

    let cuisines = "";
     if (chefDetails.chef && !isChef) {
         if (chefDetails.chef.cuisines.length > 4) {
             cuisines = chefDetails.chef.cuisines.slice(0, 4).toString() + "...";
           }
         else {
             cuisines = chefDetails.chef.cuisines.toString();
           }

           cuisines = cuisines.replace(/,/g, ", ");
       }

       let userAddress = '';
     if (booking.address) {
       const { address } = booking;
       userAddress += address.street1;
       if (address.street2) {
         userAddress += `, ${address.street2}`;
       }
       userAddress += `\n, ${address.city}, ${address.state}, ${address.zip}`;
     } else if (!!userDetails && !!userDetails.userProfile && isChef) {
       const { userProfile } = userDetails;
       if (!!userProfile.address) {
         const {address} = userProfile;

         userAddress += address.street1;

         if (address.street2) {
           userAddress += `, ${address.street2}`;
         }
         userAddress += `\n, ${address.city}, ${address.state}, ${address.zip}`;
       }
     }

     if (!!status && !!status.status && status.status === 2) {
       const bookingMoment = moment(moment(booking.date).format('DD/MM/YYYY')+ "" + booking.timeSlot.end, 'DD/MM/YYYY HH:mm');
       if (bookingMoment.isBefore(moment()))
         showDispute = true;
     }

     const breadcrumbsList = [];
     if (this.state.isScheduleScreen) {
       breadcrumbsList.push({
         display: 'Schedule',
         link: 'home/chef-schedule?option=2',
       });
       breadcrumbsList.push({
         display: 'Booking Details',
         link: 'home/chef-booking-status'
       });
     } else {
       breadcrumbsList.push({
         display: 'Bookings',
         link: `home/chef-bookings?step=${bookingBackStep}`
       });
       breadcrumbsList.push({
         display: 'Details',
         link: 'home/chef-booking-status'
       });
     }

     let showStatus = '';
     switch (booking.status) {
       case BOOKING_STATUS.PENDING:
         showStatus = 'Pending';
         break;

       case BOOKING_STATUS.ACCEPTED:
         showStatus = 'Confirmed';
         break;

       case BOOKING_STATUS.REJECTED:
         showStatus = 'Declined';
         break;

       case BOOKING_STATUS.EXPIRED:
         showStatus = 'Expired';
         break;

       case BOOKING_STATUS.INCOMPLETE:
         showStatus = 'In progress';
         break;

       case BOOKING_STATUS.COMPLETED_BY_CHEF:
       case BOOKING_STATUS.COMPLETED_BY_USER:
       case BOOKING_STATUS.COMPLETED:
         showStatus = 'Completed';
         break;

       case BOOKING_STATUS.CANCELED_BY_CHEF:
       case BOOKING_STATUS.CANCELED_APPROVED_BY_DINER:
       case BOOKING_STATUS.CANCELED_APPROVED_BY_CHEF:
       case BOOKING_STATUS.CANCELED:
       case BOOKING_STATUS.CANCELED_BY_DINER:
         showStatus = 'Canceled';
         break;
     }


    return (
      <div>
        <Header history={this.props.history} />
        {this.state.loading && <LinearProgress color={"primary"} />}
        <Grid className="booking-container" container>
          <Grid item xs={12} style={{ marginTop: 30, paddingLeft: 10}}>
            {isChef ?
              <Breadcrumbs childRoutes={breadcrumbsList} /> :
              <Breadcrumbs childRoutes={[
              {
                display: 'Bookings',
                link: `home/diner-bookings?step=${bookingBackStep}`
              },
              {
                display: 'Details',
                link: 'home/diner-booking-status'
              }
            ]} />}
          </Grid>
          <Grid item md={12}>
            <p style={{ ...style.heading, marginBottom: 0 }}>Booking details</p>
            <p style={{ ...style.userName, marginTop: 5 }}>Status: <span style={{ fontWeight: '400' }}>{showStatus}</span></p>
          </Grid>
          <Grid item md={6} lg={7} className="booking-step-row">
            <div className="booking-step-column">

              {!!status && !isNaN(status.status) && <div>
                <p style={style.message}>
                  {booking.isCustom ?
                    booking.proposalMade && booking.status === BOOKING_STATUS.REJECTED ?
                      booking.proposedBy === this.props.userId && isChef ?
                        `This booking has been declined by ${booking.userName}`
                        :booking.proposedBy !== this.props.userId && !isChef ?
                          `This booking has been declined by you.` : status.message
                      :status.message
                    :status.message}
                </p>
              </div>}
              <div
                className="booking-step-btn"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  maxWidth: 580,
                  margin: '0 auto',
                }}
              >
                <Fab
                  style={{ height: 30, width: 36 }}
                  color={!!status && status.status >= 0 ? "primary" : "default"}
                />
                <div
                  style={{
                    width: "230px",
                    borderBottom: `4px solid ${
                      !!status && status.status >= 0 ? primaryColor : "lightgray"
                    }`,
                    height: "20px"
                  }}
                />
                <Fab
                  style={{ height: 30, width: 36 }}
                  color={!!status && status.status >= 1 ? "primary" : "default"}
                />
                <div
                  style={{
                    width: "230px",
                    borderBottom: `4px solid ${
                      (!!status && status.status >= 2) || (booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_DINER ||
                      booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_CHEF) ? primaryColor : "lightgray"
                    }`,
                    height: "20px"
                  }}
                />
                <Fab
                  style={{ height: 30, width: 36 }}
                  color={(!!status && status.status === 3) || (booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_DINER ||
                  booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_CHEF) ? "primary" : "default"}
                />
              </div>
              <div style={{ maxWidth: 650, margin: '0 auto' }}>
                <div className="ipad-booking-step" style={{ display: "flex", paddingLeft: 20 }}>
                  <div>
                    <p
                      style={{
                        ...style.statusName,
                        color: primaryColor
                      }}
                    >
                      Pending
                    </p>
                  </div>
                  <div
                    style={{
                      width: "230px",
                      height: "20px"
                    }}
                  />
                  <div>
                    {booking.status === BOOKING_STATUS.REJECTED && (
                      <p
                        style={{
                          ...style.statusName,
                          color: !!status && status.status === 1 ? primaryColor : "red"
                        }}
                      />
                    )}
                    {(booking.status !== BOOKING_STATUS.ACCEPTED || booking.status !== BOOKING_STATUS.CANCELED_BY_CHEF ||
                      booking.status !== BOOKING_STATUS.CANCELED || booking.status !== BOOKING_STATUS.CANCELED_BY_DINER || booking.status !== BOOKING_STATUS.REJECTED) && (
                      <p
                        style={{
                          ...style.statusName,
                          color:
                            !!status && status.status > 0 ? primaryColor : "lightgray"
                        }}
                      >
                        {(booking.status === BOOKING_STATUS.ACCEPTED || booking.status === BOOKING_STATUS.PENDING ||
                          booking.status === BOOKING_STATUS.COMPLETED_BY_CHEF || booking.status === BOOKING_STATUS.COMPLETED_BY_USER ||
                          booking.status === BOOKING_STATUS.COMPLETED || booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_DINER ||
                          booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_CHEF
                        ) ? 'Confirmed' : (booking.status === BOOKING_STATUS.REJECTED ? 'Declined' :  booking.status === BOOKING_STATUS.EXPIRED ? 'Expired' : 'Canceled')}
                      </p>
                    )}
                  </div>
                  <div
                    style={{
                      width: "230px",
                      height: "20px"
                    }}
                  />
                  <div>
                    <p
                      style={{
                        ...style.statusName,
                        color: (!!status && status.status === 3) || (booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_DINER ||
                          booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_CHEF) ? primaryColor : "lightgray"
                      }}
                    >
                      {booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_DINER ||
                      booking.status === BOOKING_STATUS.CANCELED_APPROVED_BY_CHEF ? 'Canceled' : 'Completed'}
                    </p>
                  </div>
                </div>
              </div>
              <div>
                {booking && booking.isCustom && (
                  <p style={style.statusDesc}><strong>Description: </strong>{booking.message}</p>
                )}
              </div>
              <div>
                {booking && !!booking.rejectReason && (
                  <p style={style.statusDesc}><strong>Reason: </strong>{booking.rejectReason}</p>
                )}
              </div>
              {!this.state.showCancelModal && !this.state.askCancelBooking && <div>
                {(booking.status === BOOKING_STATUS.PENDING)
                && (
                  <Button
                    data-test-id={"cancelbkg-btn"}
                    variant={"outlined"}
                    color={"primary"}
                    style={style.buttonBigBG}
                    onClick={() => this.cancelBooking()}
                  >
                    Cancel booking
                  </Button>
                )}

                {(booking.status === BOOKING_STATUS.ACCEPTED && !isChef)
                && (booking.cancellationPolicy && booking.cancellationPolicy.allowCancellation)
                && (
                  <Button
                    data-test-id={"cancelbkg-btn"}
                    variant={"outlined"}
                    color={"primary"}
                    style={style.buttonBigBG}
                    onClick={() => this.cancelBooking()}
                  >
                    Cancel booking
                  </Button>
                )}

                {(booking.status === BOOKING_STATUS.ACCEPTED && isChef)
                  && (
                    <Button
                      data-test-id={"cancelbkg-btn"}
                      variant={"outlined"}
                      color={"primary"}
                      style={style.buttonBigBG}
                      onClick={() => this.cancelBooking()}
                    >
                      Cancel booking
                    </Button>
                  )}

                {booking.status == BOOKING_STATUS.COMPLETED && (
                  <Button
                    data-test-id={"addreviewbtn"}

                    variant={"contained"}
                    color={"primary"}
                    style={{...style.buttonBigBG, color: '#fff'}}
                    onClick={() => this.addReview(booking)}
                  >
                    Add review
                  </Button>
                )}
              </div>}
              {showDispute && !this.props.isChef && !this.state.showCancelModal && !this.state.askCancelBooking &&<div>
                <Button data-test-id={"raiseadis-btn"} color={"primary"} style={style.button} onClick={()=>this.addDispute(booking)}>
                  Raise a dispute
                </Button>
              </div>}
              {this.state.showCancelModal && <div style={{ marginTop: 30 }}>
                <Grid contianer>
                  <Grid item xs={12}>
                    <span style={{ fontSize: 15, fontWeight: '500', fontFamily: webFont, marginBottom: 10 }}>Please specify reason to cancel</span>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      multiline
                      fullWidth
                      variant="outlined"
                      value={this.state.cancelReason}
                      onChange={(evt) => this.setState({ cancelReason: evt.target.value })}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-around', fontFamily: webFont }}>
                    <Button
                      data-test-id={"cancelacceptedbookingreason"}
                      variant={"outlined"}
                      color={"primary"}
                      style={style.buttonBigBG}
                      onClick={() => this.setState({ askCancelBooking: false, showCancelModal: false })}
                    >
                      Let's keep it
                    </Button>
                    <Button
                      data-test-id={"cancelacceptedbookingreason"}
                      variant={"outlined"}
                      color={"primary"}
                      style={style.buttonBigBG}
                      disabled={this.state.cancelReason.length <= 0}
                      onClick={this.handleCancelBooking}
                    >
                      Cancel booking
                    </Button>
                  </Grid>
                </Grid>
              </div>}
              {this.state.askCancelBooking && <div style={{ marginTop: 30 }}>
                <Grid container>
                  <Grid item xs={12}>
                    <span style={{ fontSize: 15, fontWeight: '500', fontFamily: webFont, marginBottom: 10 }}>Are you sure you want to cancel booking ?</span>
                  </Grid>
                  <Grid container justify={"space-around"}>
                    <Button
                      data-test-id={"cancelacceptedbookingreason"}
                      variant={"outlined"}
                      color={"primary"}
                      style={style.buttonBG}
                      onClick={() => {
                        booking.status === BOOKING_STATUS.ACCEPTED ?
                          this.setState({ showCancelModal: true, askCancelBooking: false }) :
                          this.handleCancelBooking()
                      }}
                    >
                      Yes
                    </Button>
                    <Button
                      data-test-id={"cancelacceptedbookingreason"}
                      variant={"outlined"}
                      color={"primary"}
                      style={style.buttonSmall}
                      onClick={() => this.setState({ askCancelBooking: false })}
                    >
                      No
                    </Button>
                  </Grid>
                </Grid>
              </div>}
              <div style={{ marginTop: 30, textAlign: 'left' }}>
                <p style={{ fontSize: 14 }}>
                  <strong style={{ fontSize: 14 }}>Cancelation Policy: </strong>
                  {isChef ? <>
                    Chefs who cancel a Food Service order with less than seventy-two (72) hours before the Food Service Appointment will be charged a twenty-five dollar ($25) cancelation fee. Cuisine Crafters reserves the right to remove any Chef who often cancel Food Service orders after having accepted the Food Service order.</> : (
                      <>
                        {booking.chefName} {booking.cancellationPolicy && booking.cancellationPolicy.allowCancellation ? ' allows ' : ' disallows '} cancelation of confirmed engagements
                        {booking.cancellationPolicy && booking.cancellationPolicy.allowCancellation && booking.cancellationPolicy.penaltyCharge == 0 && ' without a fee.'}
                        {booking.cancellationPolicy && booking.cancellationPolicy.allowCancellation && booking.cancellationPolicy.penaltyCharge != 0 ? <>
                          {' '}under the following terms.
                          <ul>
                            <li style={{ textAlign: 'left' }}>No cancelation charges if canceled {' '}
                              {booking.cancellationPolicy.timeBeforeCancellation} {booking.cancellationPolicy.timeBeforeCancellationMetric} before engagement.</li>
                            <li style={{ textAlign: 'left' }}>
                              Any cancelation within {booking.cancellationPolicy.timeBeforeCancellation} {booking.cancellationPolicy.timeBeforeCancellationMetric}
                              of engagement time, will result in charge of {booking.cancellationPolicy.penaltyCharge}% of booking amount.
                            </li>
                            {booking.cancellationPolicy.allowCancellation && !!booking.cancellationPolicy.comments &&
                            <li style={{ textAlign: 'left' }}>
                              {booking.cancellationPolicy.comments ? booking.cancellationPolicy.comments.toString().charAt(0).toUpperCase() + booking.cancellationPolicy.comments.slice(1) : 'No comments'}
                            </li>}
                          </ul>
                        </> : <span></span>}
                      </>
                  )}
                </p>
              </div>
            </div>
          </Grid>
          <Grid item md={6} xs={12} sm={12} lg={5}>
            <div style={{ padding: 10 }}>
              <List className="booking-table-col" style={{ paddingBottom: 0 }}>
                <ListItem alignItems="flex-start">
                  <ListItemAvatar>
                    {isChef ? (<Avatar
                       style={{ width: 60, height: 60, marginRight: 5 }}
                       src={
                         userDetails &&
                         userDetails.userProfile &&
                         userDetails.userProfile.profilePic
                       }
                       />) :(<Avatar
                      style={{ width: 60, height: 60, marginRight: 5 }}
                      src={
                        chefDetails &&
                        chefDetails.chef &&
                        chefDetails.chef.profilePic
                      }
                    />)}
                  </ListItemAvatar>
                  <ListItemText
                    className="chef-money-details"
                    data-test-id={"card-username"}
                    primary={isChef ? booking.userName : booking.chefName}
                    style={{...style.userName, maxWidth: 280}}
                    secondary={isChef ? userAddress : cuisines}
                  />
                  {booking.isCustom && booking.status !== BOOKING_STATUS.REJECTED && <ListItemSecondaryAction style={style.userPrice}>
                    <p  data-test-id={"card-price"} style={{...style.userPrice, display: 'flex', alignItems: 'center',
                      fontSize: booking.isCustom && !booking.proposalMade ? 16 : 24 }}>
                      ${booking.isCustom && booking.status === BOOKING_STATUS.PENDING ? booking.proposalMade ? parseAmountDecimal(booking.proposedAmount) :
                        `${booking.startPrice || 0} - $${booking.endPrice || 0}` :
                      booking.isCustom ? booking.proposalMade ? parseAmountDecimal(booking.proposedAmount) :
                        `${booking.startPrice || 0} - $${booking.endPrice || 0}` : parseAmountDecimal(booking.amount)}
                    </p>
                  </ListItemSecondaryAction>}
                  {booking.isCustom && booking.status === BOOKING_STATUS.REJECTED && <ListItemSecondaryAction style={style.userPrice}>
                    <p  data-test-id={"card-price"} style={{...style.userPrice, display: 'flex', alignItems: 'center',
                      fontSize: booking.isCustom && !booking.proposalMade ? 16 : 24 }}>
                      $
                      {booking.proposalMade ? parseAmountDecimal(booking.proposedAmount) :
                          booking.startPrice ? `${booking.startPrice} - $${booking.endPrice}` : <HourglassEmptyOutlined /> }
                    </p>
                  </ListItemSecondaryAction>}
                  {!booking.isCustom && <ListItemSecondaryAction style={style.userPrice}>
                    <p  data-test-id={"card-price"} style={{...style.userPrice, display: 'flex', alignItems: 'center',
                      fontSize: booking.isCustom && !booking.proposalMade ? 16 : 24 }}>
                      $
                      {booking.isCustom && booking.status === BOOKING_STATUS.PENDING ?
                        booking.proposalMade ? parseAmountDecimal(booking.proposedAmount) :
                          booking.startPrice ? `${booking.startPrice} - $${booking.endPrice}` : <HourglassEmptyOutlined /> :
                        parseAmountDecimal(total)}
                    </p>
                  </ListItemSecondaryAction>}
                </ListItem>
                <ListItem role={undefined} dense divider style={style.listItemStyleFirst}>
                  <ListItemText primary={<p style={style.boldLabel}>Booking Id</p>} />
                  <ListItemSecondaryAction className="booking-detail-date">
                    <ListItemText
                      data-test-id={"card-bookingid"}
                      primary={booking.displayId}
                      style={style.userValue}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
                <ListItem role={undefined} dense divider style={style.listItemStyle}>
                  <ListItemText primary={<p style={style.boldLabel}>Date</p>} />
                  <ListItemSecondaryAction className="booking-detail-date">
                    <ListItemText
                    data-test-id={"card-date"}
                      primary={moment(new Date(booking.date)).format("DD MMM")}
                      style={style.userValue}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
                <ListItem role={undefined} dense divider style={style.listItemStyle}>
                  <ListItemText primary={<p style={style.boldLabel}>Time</p>} style={style.boldLabel} />
                  <ListItemSecondaryAction className="booking-detail-date">
                    <ListItemText
                    data-test-id={"card-time"}
                      primary={`${booking.isCustom ? 'Starts ' : ''}${moment(
                        booking.timeSlot.start.split(":"),
                        "hh:mm a"
                      ).format("LT")}${!booking.isCustom ? '-' : ''}
                    ${!booking.isCustom ? moment(booking.timeSlot.end.split(":"), "hh:mm a").format(
                      "LT"
                    ) : ''}`}
                      style={style.userValue}
                    />
                  </ListItemSecondaryAction>
                </ListItem>

                {booking.dishes && booking.dishes.length > 0 && <ListItem role={undefined} dense style={style.listItemStyle}>
                  <ListItemText primary={<p style={style.boldLabel}>Dishes</p>} style={style.boldLabel}/>
                  <ListItemText primary={<p style={style.boldLabel}>Serves</p>} style={style.boldLabel}/>

                  <ListItemSecondaryAction>
                    <ListItemText primary={<p style={style.boldLabel}>Price</p>} style={style.boldLabel}/>
                  </ListItemSecondaryAction>
                </ListItem>}
                {booking.dishes && booking.dishes.length > 0 && booking.dishes.map(dish => (
                  <ListItem
                    className="dish-container"
                    role={undefined}
                    dense
                    button={false}
                    key={"dishName" + dish.dishName}
                    style={style.listItemStyle}
                  >
                    <ListItemText
                      data-test-id={"card-dishname"}
                      primary={dish.dishName}
                      style={style.userDish}
                    />
                    <ListItemText data-test-id={"card-serve"} primary={dish.serves} className="card-serve-col" />

                    <ListItemSecondaryAction>
                      <ListItemText
                        className="card-serve-col"
                        data-test-id={"card-price"}
                        primary={`$ ${parseAmountDecimal(dish.price)}`}
                        style={style.userValue}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
                {!this.props.isChef && !booking.isCustom &&
                <ListItem role={undefined} dense divider style={style.listItemStyle}>
                  <ListItemText primary={<p style={style.userValue}>Service charges (5%)</p>} style={style.boldLabel}/>

                  <ListItemSecondaryAction>
                    <ListItemText
                      className="card-serve-col"
                      data-test-id={"card-amt"}
                      primary={"$ " + parseAmountDecimal(serviceCharges)}
                      style={style.userValue}
                    />
                  </ListItemSecondaryAction>
                </ListItem>}
                {!this.props.isChef && booking.isCustom && booking.status !== BOOKING_STATUS.PENDING && booking.status !== BOOKING_STATUS.REJECTED &&
                booking.status !== BOOKING_STATUS.CANCELED && booking.status !== BOOKING_STATUS.CANCELED_BY_DINER &&
                <ListItem role={undefined} dense divider style={style.listItemStyle}>
                  <ListItemText primary={<p style={style.userValue}>Service charges (5%)</p>} style={style.boldLabel}/>

                  <ListItemSecondaryAction>
                    <ListItemText
                      className="card-serve-col"
                      data-test-id={"card-amt"}
                      primary={"$ " + parseAmountDecimal(serviceCharges)}
                      style={style.userValue}
                    />
                  </ListItemSecondaryAction>
                </ListItem>}
                {!booking.isCustom && <ListItem role={undefined} dense style={style.listItemStyle}>
                  <ListItemText primary={<p style={style.boldLabel}>Total</p>} style={style.boldLabel} />

                  <ListItemSecondaryAction className="booking-total">
                    <ListItemText
                      className="card-serve-col"
                      data-test-id={"card-amt"}
                      primary={"$ " + parseAmountDecimal(total)}
                      style={style.userValue}
                    />
                  </ListItemSecondaryAction>
                </ListItem>}
                {booking.isCustom && booking.status !== BOOKING_STATUS.PENDING && booking.status !== BOOKING_STATUS.REJECTED &&
                <ListItem role={undefined} dense style={style.listItemStyle}>
                  <ListItemText primary={<p style={style.boldLabel}>Total</p>} style={style.boldLabel} />

                  <ListItemSecondaryAction className="booking-total">
                    <ListItemText
                      className="card-serve-col"
                      data-test-id={"card-amt"}
                      primary={"$ " + booking.isCustom && booking.status === BOOKING_STATUS.PENDING ? booking.proposalMade ? parseAmountDecimal(booking.proposedAmount) :
                        `$${booking.startPrice || 0} - $${booking.endPrice || 0}` :
                        booking.isCustom ? booking.proposalMade ? parseAmountDecimal(booking.proposedAmount) :
                          `$${booking.startPrice || 0} - $${booking.endPrice || 0}` : parseAmountDecimal(booking.amount)}
                      style={style.userValue}
                    />
                  </ListItemSecondaryAction>
                </ListItem>}
                {booking.isRefund && (
                  <ListItem rol={undefined} dense style={style.listItemStyleRefund}>
                    <ListItemText primary={<p style={style.boldLabel}>Refund</p>} style={style.boldLabel} />
                    <ListItemSecondaryAction className="booking-total">
                      <ListItemText
                        className="card-serve-col"
                        data-test-id={"card-amt-refund"}
                        primary={"- $ " + parseAmountDecimal(booking.refundAmount + serviceCharges)}
                        style={style.userValueRefund}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                )}
              </List>
            </div>
          </Grid>
        </Grid>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    booking: state.chefs.currentBooking,
    isChef: state.auth.isChef,
    userId: state.auth.userId,
  };
};

const Booking = connect(mapStateToProps)(DinerBookingStatus);

export default Booking;

const style = {
  heading: {
    fontSize: "30px",
    fontWeight: 500,
    fontFamily: webFont
  },
  message: {
    fontSize: "24px",
    fontFamily: webFont,
    textAlign: "center"
  },
  statusName: {
    fontSize: 20,
    fontWeight: 500,
    fontFamily: webFont
  },
  statusDesc: {
    fontSize: 15,
    fontFamily: webFont
  },
  userName: {
    fontSize: 22,
    fontWeight: 500,
    fontFamily: webFont
  },
  userAddress: {
    fontSize: 15,
    fontFamily: webFont
  },
  userLabel: {
    fontSize: 15,
    fontWeight: 400,
    fontFamily: webFont
  },
  boldLabel: {
    fontSize: 15,
    fontWeight: 500,
    fontFamily: webFont
  },
  userValue: {
    fontSize: 15,
    fontFamily: webFont
  },
  userValueRefund: {
    fontSize: 15,
    fontFamily: webFont,
    color: primaryColor
  },
  userDish: {
    fontSize: 15,
    fontFamily: webFont,
    width: 60
  },
  userPrice: {
    fontSize: 24,
    fontWeight: 500,
    color: primaryColor
  },
  button: {
    width: "240px",
    height: "48px",
    fontWeight: 'normal',
    borderRadius: "24px",
    fontSize: 15,
    fontFamily: webFont,
    textTransform: "none",
    marginTop: 10
  },
  buttonSmall: {
    width: "120px",
    height: "48px",
    fontWeight: 'normal',
    borderRadius: "24px",
    fontSize: 15,
    fontFamily: webFont,
    textTransform: "none",
    marginTop: 10,
    backgroundColor: '#ff8000',
    color: '#fff'
  },
  buttonBigBG: {
    width: "210px",
    height: "48px",
    fontWeight: 'normal',
    borderRadius: "24px",
    fontSize: 15,
    fontFamily: webFont,
    textTransform: "none",
    marginTop: 10,
    backgroundColor: '#ff8000',
    color: '#fff'
  },
  buttonBG: {
    width: "120px",
    height: "48px",
    fontWeight: 'normal',
    borderRadius: "24px",
    fontSize: 15,
    fontFamily: webFont,
    textTransform: "none",
    marginTop: 10,
    backgroundColor: '#ff8000',
    color: '#fff'
  },
  listItemStyle: {
    lineHeight: 0.5,
    height: 40,
    cursor: 'default'
  },
  listItemStyleFirst: {
    lineHeight: 0.5,
    height: 40,
    marginTop: 25
  },
  listItemStyleRefund: {
    lineHeight: 0.5,
    height: 40,
    color: primaryColor
  },
};
